import axios from 'axios'
const service=axios.create({
    baseURL:'https://www.beltandroadstudies.cn:44313/data/api',//请求地址前缀
    timeout:6000
});
//响应拦截器
service.interceptors.response.use(
    response=>{
        //拦截到成功的数据
        return response.data.result
    },
    error=>{
        //拦截到失败的数据
        return Promise.reject(error);
    }
)
export default service
